import { render, staticRenderFns } from "./SingleWindowLayout.vue?vue&type=template&id=c5cf57ee&scoped=true"
import script from "./SingleWindowLayout.vue?vue&type=script&lang=js"
export * from "./SingleWindowLayout.vue?vue&type=script&lang=js"
import style0 from "./SingleWindowLayout.vue?vue&type=style&index=0&id=c5cf57ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cf57ee",
  null
  
)

export default component.exports